import { Icon } from "@chakra-ui/react";
import React from "react";

/**
 * Renders the destination icon
 * 
 * @param {Object} props - The props of the component
 * @returns The destination icon
 */
const DestinationIcon = (props) => (
  <Icon viewBox="0 0 11 14" fill="none" {...props}>
    <path d="M0 13.5301V0.122681H11L9.49813 3.5749L11 7.02694H1.1V13.5301H0ZM1.1 5.90965H9.33735L8.30225 3.5749L9.33735 1.23996H1.1V5.90965Z" fill="currentColor" />
  </Icon>
);

export default React.memo(DestinationIcon);
